<template>
  <v-container>
    <v-row>
      <v-col col="2" v-for="select in selects" :key="select.name">
        <v-select chips="chips" outlined="outlined" :value="select.value" :items="select.items" :label="select.label" :multiple="select.multiple" :placeholder="select.placeholder"></v-select>
      </v-col>
      <v-col col="2">
        <v-select chips="chips" outlined="outlined" :value="target" :items="datasOptions" :label="$t('activity.selects.compare.label')" @change="setTarget" :placeholder="$t('activity.selects.compare.placeholder')"></v-select>
      </v-col>
      <v-col col="2">
        <v-select chips="chips" outlined="outlined" :value="display" :items="displayOptions" :label="$t('activity.selects.display.label')" :multiple="true" @change="value=>display = value" :placeholder="$t('activity.selects.display.placeholder')"></v-select>
      </v-col>
    </v-row>
    <keep-alive>
      <v-row class="mt-10 mb-10" v-if="display.includes('bar')">
        <v-col cols="12">
          <bar-chart :datasets="currentData"></bar-chart>
        </v-col>
      </v-row>
    </keep-alive>
    <keep-alive>
      <v-row class="mt-10 mb-10" v-if="display.includes('pie')">
        <v-col cols="12">
          <pie-chart :datasets="currentData"></pie-chart>
        </v-col>
      </v-row>
    </keep-alive>
    <keep-alive>
      <v-row class="mt-10 mb-10" v-if="display.includes('line')">
        <v-col cols="12">
          <line-chart :datasets="currentData"></line-chart>
        </v-col>
      </v-row>
    </keep-alive>
  </v-container>
</template>

<script>
import { ANALYTICS_OPERATION_DATA } from '@/libs/fakeData'
import { mapGetters, mapActions } from 'vuex'
import BarChart from '@/components/Charts/Analytics/Bar'
import PieChart from '@/components/Charts/Analytics/Pie'
import LineChart from '@/components/Charts/Analytics/Line'

export default {
  components: { BarChart, PieChart, LineChart },
  data () {
    return {
      operationData: ANALYTICS_OPERATION_DATA,
      display: ['bar'],
      displayOptions: [
        { text: this.$t('chart.displayOptions.bar'), value: 'bar' },
        { text: this.$t('chart.displayOptions.pie'), value: 'pie' },
        { text: this.$t('chart.displayOptions.line'), value: 'line' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selects: 'activity/selects',
      target: 'activity/target',
      datasOptions: 'activity/datasOptions',
      currentData: 'activity/currentData'
    })
  },
  methods: {
    ...mapActions({
      setTarget: 'activity/setTarget'
    })
  }
}
</script>
